export default import.meta.ROLLDOWN_FILE_URL_qP_r83IlryRG0BoT2_MBkA